import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { IBannerPageCardProps } from '../../../../interfaces/Website/Banners/IBanners'
import BannerPageCard from './BannerPageCard'

function BannerPageSortableBanner(props: IBannerPageCardProps & { id: string }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: props.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <BannerPageCard {...props} />
    </div>
  )
}

export default BannerPageSortableBanner
